export default "__VITE_ASSET__COicVOg9__"